/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import { PageTitle } from "../../components/layout/core";
const ReportsView: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: "MENU.ReportsView" })}
      </PageTitle>
      <h1>teacher</h1>
    </>
  );
};

export { ReportsView };
